import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import UserProfileMenu from '../components/UserProfileMenu';
import { useTranslation } from 'react-i18next';

const logo = "https://storage.googleapis.com/connct-cba18.firebasestorage.app/frontend-assets/Conncct-logo.png";

// TypeScript declaration for Calendly
declare global {
  interface Window {
    Calendly?: any;
  }
}

export default function DemoSchedule() {
  const location = useLocation();
  const demoData = location.state?.demoData || {};
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const isAuthenticated = !!localStorage.getItem('user');

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
    document.dir = newLang === 'ar' ? 'rtl' : 'ltr';
  };

  useEffect(() => {
    // Wait for Calendly to be available and initialize the widget
    const initCalendly = () => {
      if (window.Calendly) {
        console.log('Calendly loaded successfully');

        // Initialize the inline widget
        window.Calendly.initInlineWidget({
          url: 'https://calendly.com/conncct/consultancy?month=2026-01',
          parentElement: document.getElementById('calendly-container'),
          prefill: {
            name: `${demoData.firstName || ''} ${demoData.lastName || ''}`.trim(),
            email: demoData.email || '',
            customAnswers: {
              a1: demoData.companyName || '',
              a2: demoData.helpWith || '',
              a3: demoData.discussionTopic || ''
            }
          }
        });
      } else {
        // Wait for Calendly to load
        console.log('Waiting for Calendly to load...');
        setTimeout(initCalendly, 100);
      }
    };

    initCalendly();
  }, [demoData]);

  return (
    <div className="min-h-screen bg-white flex flex-col" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Header */}
      <header className="flex items-center justify-between px-8 py-4 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <Link to={isAuthenticated ? "/dashboard" : "/"}>
            <img
              src={logo}
              alt="Connct Logo"
              className="h-8 object-contain"
            />
          </Link>
        </div>
        <div className="flex items-center gap-4">
          <button
            onClick={toggleLanguage}
            className="text-sm text-gray-700 hover:text-gray-900"
          >
            {i18n.language === 'en' ? 'العربية' : 'English'}
          </button>
          {isAuthenticated ? (
            <UserProfileMenu />
          ) : (
            <Link
              to="/login"
              className="px-6 py-2 bg-black text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition"
            >
              {t('nav.signIn')}
            </Link>
          )}
        </div>
      </header>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-8 py-12">
        <div className="w-full max-w-5xl">
          {/* Title */}
          <div className="text-center mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('demoSchedule.title')}
            </h1>
            <p className="text-gray-600 text-base">
              {t('demoSchedule.subtitle')}
            </p>
          </div>

          {/* Calendly Embed */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
            <div
              id="calendly-container"
              style={{ minWidth: '320px', height: '700px' }}
            ></div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              {t('demoSchedule.noTime')}{' '}<Link to="/contact" className="text-blue-600 hover:underline">{t('demoSchedule.contactUs')}</Link>
            </p>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <footer className="py-6 text-center text-sm text-gray-500 border-t border-gray-100">
        <p>
          {t('demoSchedule.footer')}{' '}
          <a href="#" className="text-blue-600 hover:underline">{t('demoSchedule.termsOfService')}</a>{' '}
          {t('demoSchedule.and')}{' '}
          <a href="#" className="text-blue-600 hover:underline">{t('demoSchedule.privacyPolicy')}</a>
        </p>
      </footer>
    </div>
  );
}
